import {
  DataProvider,
  IErrorModel,
  useMutation,
  UseMutationOptions,
} from "@nf/common";

type SwitchOfferOptions = UseMutationOptions<
  void,
  IErrorModel,
  { subscription_id: number; to_offer_id: number }
>;

export const useSwitchOffer = (options: SwitchOfferOptions) => {
  return useMutation<
    void,
    IErrorModel,
    { subscription_id: number; to_offer_id: number }
  >((data) => DataProvider.switchSubscription(data), options);
};
